
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prepare-for-competitions/refresher-videos",
      function () {
        return require("private-next-pages/prepare-for-competitions/refresher-videos.tsx");
      }
    ]);
  